import { render, staticRenderFns } from "./CategoryTierGroup.vue?vue&type=template&id=82c610e0&scoped=true"
import script from "./CategoryTierGroup.vue?vue&type=script&lang=js"
export * from "./CategoryTierGroup.vue?vue&type=script&lang=js"
import style0 from "./CategoryTierGroup.vue?vue&type=style&index=0&id=82c610e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82c610e0",
  null
  
)

export default component.exports